module.exports = __webpack_public_path__ + "img/bocaiIcon.53b9533c.svg";